import { useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';

export interface PriceToIncomeRatioRecord {
  Place: string;
  place_fips: string;
  year: string | number;
  price_to_income: number;
}

export function usePriceToIncomeRatioData(place: string | null, placeFips: string | null) {
  const [data, setData] = useState<PriceToIncomeRatioRecord[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!place || !placeFips) {
      setLoading(false);
      setData([]);
      setError(null);
      return;
    }

    setLoading(true);
    setError(null);

    supabase
      .from('acs_bps_metrics_housing_affordability')
      .select('Place, place_fips, year, price_to_income')
      .eq('Place', place)
      .eq('place_fips', placeFips)
      .order('year', { ascending: true })
      .then(({ data: supabaseData, error: supabaseError }) => {
        if (supabaseError) {
          console.error('Error fetching price to income ratio data:', supabaseError);
          setError(supabaseError.message);
          setData([]);
        } else {
          setData(supabaseData || []);
          // Log the latest record for the selected city
          const latest = (supabaseData || []).slice(-1)[0];
          if (latest) {
            console.log(`Selected City: ${latest.Place}`);
            console.log(`  FIPS: ${latest.place_fips}`);
            console.log(`  Price to Income Ratio: ${latest.price_to_income?.toFixed(2)}`);
            console.log(`  Year: ${latest.year}`);
          }
        }
        setLoading(false);
      });
  }, [place, placeFips]);

  return { data, loading, error };
} 